import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderSuccessPage from "@/pages/OrderSuccessPage";
import CustomOrderPage from "@/pages/CustomOrderPage";
import LoginPage from "@/pages/LoginPage";
import AccountPage from "@/pages/AccountPage";
import AboutPage from "@/pages/AboutPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import WishlistPage from "@/pages/WishlistPage";
import AdminApp from "@/pages/AdminApp";

function Storefront({ children }) { return <Layout>{children}</Layout>; }

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Outfit, sans-serif", background: "#1C1917", color: "#fff", borderRadius: 0 } }} />
          <Routes>
            <Route path="/admin/*" element={<AdminApp/>} />
            <Route path="/" element={<Storefront><HomePage/></Storefront>} />
            <Route path="/shop/:category" element={<Storefront><ShopPage/></Storefront>} />
            <Route path="/product/:slug" element={<Storefront><ProductDetailPage/></Storefront>} />
            <Route path="/cart" element={<Storefront><CartPage/></Storefront>} />
            <Route path="/checkout" element={<Storefront><CheckoutPage/></Storefront>} />
            <Route path="/order-success/:id" element={<Storefront><OrderSuccessPage/></Storefront>} />
            <Route path="/custom-order" element={<Storefront><CustomOrderPage/></Storefront>} />
            <Route path="/login" element={<Storefront><LoginPage/></Storefront>} />
            <Route path="/account" element={<Storefront><AccountPage/></Storefront>} />
            <Route path="/about" element={<Storefront><AboutPage/></Storefront>} />
            <Route path="/track-order" element={<Storefront><TrackOrderPage/></Storefront>} />
            <Route path="/wishlist" element={<Storefront><WishlistPage/></Storefront>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
